import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {BlogService} from '../service/blog.service';
import * as articleActions from '../action/article.action';
import {catchError, exhaustMap, timeout} from 'rxjs/operators';
import {map, of} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import {trackArticle, trackArticleFailure, trackArticleSuccess} from "../action/track.action";


@Injectable()
export class ArticleEffect {
  article$ = createEffect(() => this
    .actions$
    .pipe(ofType(articleActions.article),
      exhaustMap((params) => this
        .blogService
        .slug(params.slug)
        .pipe(
          timeout(10000), // 10 second timeout for HTTP requests
          map(blog => {
            console.log(`Article effect received data for ${params.slug}:`, blog);
            return blog.Items.length ?
              articleActions.articleSuccess({article: blog.Items[0]}) :
              articleActions.articleFailure(({error: '404'}));
          }),
          catchError((httpErrorResponse: HttpErrorResponse) => {
            console.warn(`Article effect error for slug: ${params.slug}`, httpErrorResponse);
            return of(articleActions.articleFailure(({error: httpErrorResponse.error || 'timeout'})));
          })))));

  track$ = createEffect(() => this
    .actions$
    .pipe(ofType(trackArticle),
      exhaustMap(({resource}) => this
        .blogService
        .track(resource)
        .pipe(map(() => trackArticleSuccess()),
          catchError((httpErrorResponse: HttpErrorResponse) =>
            of(trackArticleFailure(({error: httpErrorResponse.error}))))))));

  constructor(
    private actions$: Actions,
    private blogService: BlogService
  ) {
  }
}
